import i18n from "../i18n";
import ValidationResult from "../interfaces/api/validation-result";

export const validateLandmarkName = (name: string | null, takenNames: string[]): ValidationResult => {
  if (name == null || name.length === 0) {
    return { isValid: false, error: i18n.t("validation-error-name-empty") };
  }
  if (name.length > 80) {
    return {
      isValid: false,
      error: i18n.t("validation-error-name-too-long"),
    };
  }

  const specialChars = /[`!@#$%^&*()+=[\]{};':"\\|,.<>/?~]/;
  if (specialChars.test(name)) {
    return { isValid: false, error: i18n.t("validation-error-name-includes-special-chars") };
  }

  if (takenNames != null && takenNames.some((n) => n === name)) {
    return { isValid: false, error: i18n.t("validation-error-name-duplicate") };
  }

  return { isValid: true, error: null };
};
